import { Bounds } from 'google-map-react';

import { apiUrl } from '../../../../../constants/global';

export default function getSearchUrl({
  bounds,
  minDist,
  query,
  postcode,
  distance,
  categoryId,
}: {
  bounds: Bounds;
  minDist: number;
  query?: string;
  postcode?: string;
  distance?: number;
  categoryId?: number;
}) {
  let url = `${apiUrl}clusters?area=${bounds.nw.lat},${bounds.nw.lng},${bounds.se.lat},${bounds.se.lng}&minDist=${minDist}`;

  // prevent query param injection for all string user input for example if user searched for `fiets&categoryId=8`

  if (query) {
    url = `${url}&query=${encodeURIComponent(query)}`;
  }

  if (postcode) {
    url = `${url}&postcode=${encodeURIComponent(postcode)}`;
  }

  if (distance) {
    url = `${url}&distance=${distance}`;
  }

  if (categoryId) {
    url = `${url}&categoryId=${categoryId}`;
  }

  return url;
}
